var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Multivariate Dependencies
import React, { useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
// Components
import Portal from '../utils/portals/Portal';
import { ReactResizeObserver } from '../ReactResizeObserver/ReactResizeObserver';
// Styles
import styled from 'styled-components';
// Utils
import { classNames } from 'ezyvet-fe-helpers';
import { centerPopupPosition } from './utils/centerPopupPosition';
// Types
import { EMPTY_ARRAY } from '../types/objects/EMPTY_ARRAY';
import { Z_INDEX } from '../types/ui/zIndexConstants';
import { FormBoxEnums } from './types/FormBoxEnums';
/**
 * @deprecated Do not use legacy components anymore.
 */
var StyledFormBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n\n  &.contentLoading {\n    display: none;\n  }\n\n  & .formbox_inner {\n    position: absolute;\n    margin: auto;\n    min-width: 100px;\n    width: auto;\n    display: block;\n    overflow: visible;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n\n  &.contentLoading {\n    display: none;\n  }\n\n  & .formbox_inner {\n    position: absolute;\n    margin: auto;\n    min-width: 100px;\n    width: auto;\n    display: block;\n    overflow: visible;\n  }\n"])));
/**
 * @deprecated Do not use legacy components anymore.
 */
var FormBox = function (_a) {
    var id = _a.id, basePosition = _a.basePosition, _b = _a.isDirty, isDirty = _b === void 0 ? false : _b, _c = _a.classes, classes = _c === void 0 ? EMPTY_ARRAY : _c, goBack = _a.goBack, children = _a.children;
    var innerPopup = useRef(null);
    var _d = useState({ x: 0, y: 0 }), currentPosition = _d[0], setPosition = _d[1];
    useEffect(function () {
        var resizeFunction = function () { return centerPopupPosition(innerPopup, setPosition, basePosition); };
        window.addEventListener('resize', resizeFunction);
        return function () {
            window.removeEventListener('resize', resizeFunction);
        };
    }, []);
    var onDrag = function (_, data) { return setPosition({ x: data.x, y: data.y }); };
    var onBackgroundClick = function (e) {
        // We only want to go back for direct clicks
        if (e.target === e.currentTarget) {
            // TODO: Implement dirty logic as part of the forms used
            if (isDirty) {
                // eslint-disable-next-line no-alert
                if (window.confirm(FormBoxEnums.confirmationPrompt) === true) {
                    goBack();
                }
            }
            else {
                goBack();
            }
        }
    };
    return (React.createElement(Portal, null,
        React.createElement(StyledFormBox, { id: id, style: { zIndex: Z_INDEX.MODAL }, className: classNames(__spreadArray(['formbox'], classes, true)), onMouseDown: onBackgroundClick, role: 'presentation' },
            React.createElement(Draggable, { handle: '.popupFormHeader', onDrag: onDrag, position: currentPosition },
                React.createElement("div", { className: 'formbox_inner popup_element ui-widget-content', ref: innerPopup },
                    children,
                    React.createElement(ReactResizeObserver, { onResize: function () { return centerPopupPosition(innerPopup, setPosition, basePosition); } }))))));
};
export default FormBox;
var templateObject_1;
//# sourceMappingURL=FormBox.js.map